import * as Types from '../../../gql/types';

import {gql} from '@apollo/client';
import {PosterDetailsFragmentDoc} from '../../../gql/fragments/poster-details';
import {PosterOptionsFragmentDoc} from '../../../gql/fragments/poster-options';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SavePreviewMutationVariables = Types.Exact<{
  poster: Types.PosterInput;
}>;

export type SavePreviewMutation = {
  __typename?: 'Mutation';
  savePreview?: {
    __typename?: 'SavePreviewPayload';
    poster?: {
      __typename?: 'Poster';
      id: string;
      name: string;
      variant: Types.PosterVariant;
      activitiesStartDate: any;
      activitiesEndDate: any;
      activityTypes: Array<Types.ActivityType>;
      baseColor: any;
      highlightColor: any;
      image: {__typename?: 'Image'; url: any};
      options: {
        __typename?: 'PosterOptions';
        activityTypes: Array<Types.ActivityType>;
        colors: Array<any>;
      };
    } | null;
    errors: Array<{__typename?: 'Error'; message: string}>;
  } | null;
};

export const SavePreviewDocument = gql`
  mutation savePreview($poster: PosterInput!) {
    savePreview(poster: $poster) {
      poster {
        ...posterDetails
        image(transform: ORIGINAL) {
          url
        }
        ...posterOptions
      }
      errors {
        message
      }
    }
  }
  ${PosterDetailsFragmentDoc}
  ${PosterOptionsFragmentDoc}
`;
export type SavePreviewMutationFn = ApolloReactCommon.MutationFunction<
  SavePreviewMutation,
  SavePreviewMutationVariables
>;

/**
 * __useSavePreviewMutation__
 *
 * To run a mutation, you first call `useSavePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePreviewMutation, { data, loading, error }] = useSavePreviewMutation({
 *   variables: {
 *      poster: // value for 'poster'
 *   },
 * });
 */
export function useSavePreviewMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SavePreviewMutation,
    SavePreviewMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    SavePreviewMutation,
    SavePreviewMutationVariables
  >(SavePreviewDocument, options);
}
export type SavePreviewMutationHookResult = ReturnType<
  typeof useSavePreviewMutation
>;
export type SavePreviewMutationResult =
  ApolloReactCommon.MutationResult<SavePreviewMutation>;
export type SavePreviewMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SavePreviewMutation,
  SavePreviewMutationVariables
>;
